import { api } from '@whitesharx/starfall-frontend-core';

export type AnalyzeMoveRequestParam = {
  fen: string;
  move: string;
};

export type MoveScoreResponse = {
  cp?: string;
  mate?: string;
};

export type AnalyzedMoveResponse = {
  move: string;
  score: MoveScoreResponse;
};

export type AnalyzeRequestResponse = {
  current: AnalyzedMoveResponse;
  best: AnalyzedMoveResponse;
};

export const analyzeRequest = ({ fen, move }: AnalyzeMoveRequestParam) => {
  const request = (retries: number) =>
    new Promise<AnalyzeRequestResponse>((resolve, reject) => {
      api.analysis
        .get(`analysis?fen=${fen}&move=${move}`)
        .then((data) => resolve(data as AnalyzeRequestResponse))
        .catch((error) => {
          console.error('Analyze request with given params failed: ', { fen, move });

          if (retries !== 4) {
            return request(retries + 1);
          }

          reject(new Error('Analyze request failed after several retries', error));
        });
    });

  return request(0);
};
